import axios from 'axios';
import { appEnvironment } from '../config/appEnvironment';
import { getBearerToken } from '@/app/cookies';
import { appStorageController } from '@/app/storage';

export const api = axios.create({
    baseURL: appEnvironment.API_URL,
    withCredentials: true,
});

api.interceptors.request.use(config => {
    const token = getBearerToken();
    if (token) config.headers['Authorization'] = token;

    const locale = appStorageController.get('i18nextLng') ?? 'ru';
    config.headers['locale'] = locale;

    return config;
});
